/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit2_TInputs */

const en_csv_to_json_pit2_t = /** @type {(inputs: Csv_To_Json_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the comma is treated as a delimiter`)
};

const ko_csv_to_json_pit2_t = /** @type {(inputs: Csv_To_Json_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉼표만 구분자로 취급됩니다`)
};

const ja_csv_to_json_pit2_t = /** @type {(inputs: Csv_To_Json_Pit2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマだけが区切り文字として扱われます`)
};

/**
* | output |
* | --- |
* | "Only the comma is treated as a delimiter" |
*
* @param {Csv_To_Json_Pit2_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit2_t = /** @type {((inputs?: Csv_To_Json_Pit2_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit2_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit2_t(inputs)
	if (locale === "ko") return ko_csv_to_json_pit2_t(inputs)
	return ja_csv_to_json_pit2_t(inputs)
});